@if(btn_type === 1){
<button type="button" class="btn btn-sm btn-primary" (click)="openTreatmentModal();">
	Quotation
</button>
}@else if(btn_type === 2){
<button type="button" class="btn btn-xs btn-primary" (click)="openTreatmentModal();" matTooltip="Edit">
	@if (loadingTreatmentCosts) {
	<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
	}@else {
	<fa-icon [icon]="['fas','pencil-alt']"></fa-icon>
	}
</button>
}
<div class="modal fade" id="{{modalId}}" role="dialog">
	<div class="modal-dialog modal-lg">
		<form [formGroup]="treatmentForm" (ngSubmit)="saveTreatmentExpense()">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">
						<strong>
							Quotation
						</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-6">
							<ng-select [ngClass]="{'is-invalid':showErrorTreatment('icdcode_id')}"
								[items]="icd_code_list" bindLabel="name" bindValue="id" id="icdcode_id"
								formControlName="icdcode_id" placeholder="ICD Code*" [appearance]="'outline'"
								[clearable]="true" [loading]="loadingICD" addTagText="Create New:"
								[addTag]="addICDCode.bind(this)">
							</ng-select>
							<p *ngIf="showErrorTreatment('icdcode_id')" class="text-danger">
								<span *ngIf="f3.icdcode_id.errors?.required">
									Required
								</span>
								<span *ngIf="f3.icdcode_id.errors?.incorrect">
									{{customErrorTreatment.icdcode_id}}
								</span>
							</p>
						</div>
						<div class="col-6">
							<ng-select [ngClass]="{'is-invalid':showErrorTreatment('hospital_id')}"
								[items]="hospitalList" bindLabel="name" bindValue="id" [clearable]="true"
								id="hospital_id" formControlName="hospital_id" placeholder="Medical Center*"
								[appearance]="'outline'">
							</ng-select>
							<p *ngIf="showErrorTreatment('hospital_id')" class="text-danger">
								<span *ngIf="f3.hospital_id.errors?.required">
									Required
								</span>
								<span *ngIf="f3.hospital_id.errors?.incorrect">
									{{customErrorTreatment.hospital_id}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-6">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showErrorTreatment('treatment')}"
									id="treatment" formControlName="treatment" placeholder="">
								<label>Treatment*</label>
							</div>
							<p *ngIf="showErrorTreatment('treatment')" class="text-danger">
								<span *ngIf="f3.treatment.errors?.required">
									Required
								</span>
								<span *ngIf="f3.treatment.errors?.incorrect">
									{{customErrorTreatment.treatment}}
								</span>
							</p>
						</div>
						<div class="col-6">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showErrorTreatment('amount')}"
									id="amount" formControlName="amount" placeholder="">
								<label>Amount*</label>
							</div>
							<p *ngIf="showErrorTreatment('amount')" class="text-danger">
								<span *ngIf="f3.amount.errors?.required">
									Required
								</span>
								<span *ngIf="f3.amount.errors?.pattern">
									Invalid
								</span>
								<span *ngIf="f3.amount.errors?.incorrect">
									{{customErrorTreatment.amount}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-6">
							<label>Upload Quotation</label>
							<app-file-upload [allowedFiles]="allowedQuotationFiles" [uploadFolder]="'quotation'"
								(uploaded)="quotationFileUploaded($event)">
							</app-file-upload>
							<p *ngIf="showErrorTreatment('quotation')" class="text-danger">
								<span *ngIf="f3.quotation.errors?.required">
									Required
								</span>
								<span *ngIf="f3.quotation.errors?.incorrect">
									{{customErrorTreatment.quotation}}
								</span>
							</p>
						</div>
						<div class="col-6">
							@if (f3.quotation.value) {
							<label>Uploaded Quotation</label>
							<br />
							<div class="icon-container no-delete">
								<file-icon [file]="f3.quotation.value"></file-icon>
							</div>
							}
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success">
						@if(saveTreatmentLoader){
						<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
						}@else{
						<fa-icon [icon]="['fas','save']"></fa-icon>
						}
						Save
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</div>
		</form>
	</div>
</div>